/**
 * Forgot Password Route
 * Public route - no authentication required
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/forgotpassword')({
  // No beforeLoad - public route
});
